import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';


import {style} from '../../../components/pdf/fontstyles';
import {AutoText} from '../../../components/pdf/autoText'; 




const styles = StyleSheet.create({
  page: {
    padding: 10, // Reduce padding

    fontSize: 10,
    marginLeft: 40,
    marginRight: 40,
    marginTop: 10,
    marginBottom: 10,
    lineHeight: 1.5,

  },
  table: {
    marginTop: 10,
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles (adjust widths for each column)
  srNoCell: {
    width: '10%', // First column with smaller width
  },
  detailsCell: {
    width: '70%', // Second column with larger width
  },
  pageNoCell: {
    width: '20%', // Third column with medium width
  },
});
const tableData = [
  ['1', 'Annexure A –Departmental Data Sheet', ''],
  ['2', 'School Letter', ''],
  ['3', 'Employee Letter', ''],
  ['4', 'Form A or B: Commutation of Pension', ''],
  ['5', 'FORM No. 15: ANNEXURE I\n\t                        ANNEXURE II', ''],
  ['6', 'Specimen signature and Passport size photo', ''],
  ['7', 'Thumb, Finger Impression and Identification Mark', ''],
  ['8', 'Form 3: Details of Family', ''],
  ['9', 'Form 1: Nomination for Death-Cum -Retirement Gratuity', ''],
  ['10', 'Last Pay Certificate', ''],
  ['11', 'Sources of pay drawn', ''],
  ['12', 'Periods of Vacations', ''],
  ['13', 'Service Break', ''],
  ['14', 'Service History', ''],
  ['15', 'A Statement Of Leave Availed By Employee', ''],
  ['16', 'Rough Calculation of Pension & gratuity', ''],
  ['17', 'A Declaration For Pension / Service Gratuity And / Or D.C.R. Gratuity / Family Pension', ''],
  ['18', 'A Declaration for pension / Gratuity', ''],
  ['19', 'No departmental enquiry and No. Government or management dues', ''],
  ['20', 'Certificate: School is 100% aided by School Education & Sports Dept.', ''],
  ['21', 'Consent form', ''],
  ['22', 'Non Employment Certificate', ''],
  ['23', 'वचनपत्र: २२.१२.२०२१ चे सहपत्र', ''],
  ['24', 'Certificates: Misc.', ''],
];


const PensionEnclosure = () => (
  <View style={styles.page}>
    <Text style={[style.ArialBold, { textAlign: 'center', fontSize: 16, marginTop: 20, marginBottom: 10 }]}>
      LIST OF ENCLOSURES
    </Text>
    <View style={styles.table}>
      <View style={[styles.row, styles.headerCell]}>
        <Text style={[styles.cell, styles.srNoCell]}>SR. No</Text>
        <Text style={[styles.cell, styles.detailsCell]}>Details</Text>
        <Text style={[styles.cell, styles.pageNoCell]}>Page No</Text>
      </View>
      
      {tableData.map(([srNo, details, pageno], index) => (
        <View style={styles.row} key={index}>
          <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
          <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
          <Text style={[styles.cell, styles.pageNoCell]}>{pageno}</Text>
        </View>
      ))}
    </View>
  </View>
);

export default PensionEnclosure;
